import styled from 'styled-components'
import { bp } from 'lib/core/resources/helpers/styled'

export const Wrapper = styled.div<any>`
  display: flex;
  align-items: flex-start;
  width: 100%;
  ${bp('lg')`
    margin-bottom: 30px;
  `}

  .slider {
    max-width: 400px;

    &-control-centerleft,
    &-control-centerright {
      button {
        background: transparent;
        border: none;
        cursor: pointer;

        svg {
          g {
            fill: black;
          }
        }
      }
    }

    &-control-centerright {
      right: -36px !important;
    }

    &-control-centerleft {
      left: -36px !important;
    }

    &-control-bottomcenter {
      ${props => props.removeDots && `
        display: block !important;
      `}

      bottom: -35px !important;

      .paging-item {
        button {
          fill: ${props => props.theme.palette.general.gray};
        }

        &.active {
          button {
            ${props => props.theme.palette.general.grayDark};
          }
        }
      }
    }
  }
`

export const GalleryWrapper = styled.div`
  margin-right: 10%;

  .slider {
    &-frame {
      min-height: 380px !important;
    }

    &-slide {
      height: 95px !important;

      &:focus {
        outline: none;
      }
    }

    &-list {
      pointer-events: none;
    }
  }
`

export const GalleryItem = styled.div`
  cursor: pointer;
  border-bottom: 4px solid transparent;
  box-sizing: border-box;
  height: 95px;
  display: flex;
  justify-content: center;
  pointer-events: all;

  &.selected {
    border-color: ${props => props.theme.palette.primary.alphaDark};
  }

  img {
    object-fit: contain;
  }
`
